export default {
  errors: null,
  accounts: [],
  account: null,
  loading: false,
  count: 0,
  totalCount: 0,
  loaded: false,
};
